<div class="widget widget_meta">
    <h2 class="widget-title">Meta</h2>
    <ul>
        <li *ngFor="let list of List"><a href='#'>{{ list.title }}</a></li>
    </ul>
</div>